<template>
  <div class="dash-card latest-news-widget">
    <div class="dash-card-header">
      <h3 class="dash-card-title">
        <span
          class="dash-card-title-icon"
          style="background: #f6ffed; color: #52c41a"
        >
          <a-icon type="file-text" />
        </span>
        {{ $t("accueil.dashboard.latestNews") }}
      </h3>
      <span class="dash-card-action" @click="goToActuality">
        {{ $t("accueil.dashboard.seeAllNews") }}
        <a-icon type="right" />
      </span>
    </div>

    <div class="dash-card-body">
      <div v-if="news.length" class="news-list">
        <div
          v-for="item in news"
          :key="item._id"
          class="news-item dash-focusable"
          tabindex="0"
          @click="goToActualityDetails(item)"
        >
          <div class="news-thumb">
            <img
              v-if="photoUrl(item)"
              :src="photoUrl(item)"
              alt=""
            />
            <div v-else class="news-thumb-placeholder">
              <a-icon type="picture" />
            </div>
          </div>
          <div class="news-content">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-desc" v-html="item.desc"></div>
            <div class="news-meta">
              <span class="dash-badge dash-badge-success">{{
                categoryLabel(item.category)
              }}</span>
              <span class="news-date">{{ formatDate(item.createdAt) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="dash-empty-state news-empty">
        <div class="dash-empty-icon">
          <a-icon type="file-text" />
        </div>
        <div>{{ $t("accueil.dashboard.noNews") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "LatestNewsWidget",
  props: {
    news: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["settings"]),
  },
  methods: {
    formatDate(date) {
      return moment(date).fromNow();
    },
    categoryLabel(category) {
      if (!category) return "";
      if (category === "album") return this.$t("actualite.album");
      const map = {
        info: "actualite.categoryInfo",
        important_info: "actualite.categoryImportantInfo",
        urgent: "actualite.categoryUrgent",
        avis_important: "actualite.categoryAvisImportant",
        avis: "actualite.categoryAvis",
        important: "actualite.categoryImportant",
      };
      return map[category] ? this.$t(map[category]) : category;
    },
    photoUrl(item) {
      const photo = item && item.photos && item.photos[0];
      if (!photo) return null;
      if (typeof photo === "string" && photo.startsWith("http")) return photo;
      const base = this.settings && this.settings.resourcesUrl;
      if (!base) return null;
      return base.replace("FILE_PATH", photo);
    },
    goToActuality() {
      if (this.$route.path !== "/actuality") {
        this.$router.push({ path: "/actuality" });
      }
    },
    goToActualityDetails(item) {
      if (!item || !item._id) return;
      const path = `/actuality/${item._id}`;
      if (this.$route.path !== path) {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.latest-news-widget {
  display: flex;
  flex-direction: column;
}

.dash-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.news-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 160px;
}

.news-item {
  display: flex;
  gap: 12px;
  padding: 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;

  &:hover,
  &:focus-visible {
    background: #fafafa;
    transform: translateX(2px);
  }
}

.news-thumb {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  background: linear-gradient(135deg, #e6f7ff, #f6ffed);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.news-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #91d5ff;
  font-size: 22px;
}

.news-content {
  flex: 1;
  min-width: 0;
}

.news-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #262626;
  margin-bottom: 3px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-desc {
  font-size: 0.75rem;
  color: #8c8c8c;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 6px;

  ::v-deep p {
    margin: 0;
  }
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 8px;

  .news-date {
    font-size: 0.68rem;
    color: #bfbfbf;
  }
}

[data-kit-theme="dark"] {
  .news-item:hover,
  .news-item:focus-visible {
    background: #141322;
  }

  .news-title {
    color: #aeaee0;
  }

  .news-thumb {
    background: linear-gradient(135deg, #141322, #232135);
  }
}
</style>
